<template>
  <div class="custom-date-picker">
    <slot name="label" v-if="label">
      <label :for="id" class="va-input__container__label">
        {{label}}
      </label>
    </slot>
    <div class="date-picker-wrapper" :class="{'with-errors': error}">
      <va-date-picker
        :id="id"
        :value="value"
        :config="datePickerConfig"
        :disabled="disabled"
        @input="value => $emit('input', value)"
        :placeholder="placeholder"
      >
        <span slot="append-icon">
          <span class="d-flex justify-content-end align-items-center">
            <span @click.stop="$emit('input', null)" v-if="value && clearable && !disabled" class="clickable clear-datepicker-icon">
              <va-icon name="fa fa-times"></va-icon>
            </span>
            <slot name="icon">
              <va-icon :class="iconClass"></va-icon>
            </slot>
          </span>
        </span>
      </va-date-picker>

    </div>
    <div class="text-danger text-break" v-if="error">
      <small v-for="(error, index) in errorMessages" :key="index">
        {{error}}
      </small>
    </div>
  </div>
</template>

<script>
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
import { Portuguese as PTLocale } from 'flatpickr/dist/l10n/pt'
import { Spanish as ESLocale } from 'flatpickr/dist/l10n/es'

PTLocale.firstDayOfWeek = 1
PTLocale.rangeSeparator = ' a '

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    value: {
      required: false
    },
    config: {
      type: Object,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '---'
    },
    disabled: {
      type: Boolean,
      required: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: true
    },
    error: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessages: {
      type: Array,
      required: false
    },
    iconClass: {
      type: String,
      required: false,
      default: 'fa fa-calendar'
    }
  },
  mixins: [
    CurrentLocaleMixin
  ],
  computed: {
    datePickerConfig: function () {
      let config = {}

      if (this.locale === 'pt') {
        config.locale = PTLocale
      } else if (this.locale === 'es') {
        config.locale = ESLocale
      } else {
        config.locale = { firstDayOfWeek: 1 }
      }

      Object.assign(config, this.config)
      return config
    }
  }
}
</script>

<style lang="scss">

.custom-date-picker {
  .flatpickr-time {
    height: 40px !important;
  }
}

</style>
